(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9129],{

/***/ 39386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esg-guide",
      function () {
        return __webpack_require__(86904);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ esg_guide; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/esg-guide/Esg-guide-styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow-x: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 30px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 5px solid #3bb77e;\n  width: 70px;\n  margin-top: 15px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  word-break: keep-all;\n  & p {\n    color: #343a40;\n    line-height: 3;\n    font-size: 18px;\n    @media screen and (max-width: 991px) {\n      line-height: 2;\n    }\n  }\n  & span {\n    margin-left: 10px;\n    color: #3bb77e;\n  }\n  margin-bottom: 75px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 150px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border-left: 5px solid #3bb77e;\n  padding-left: 30px;\n  margin-bottom: 150px;\n  word-break: keep-all;\n  & span {\n    color: #3bb77e;\n  }\n\n  @media screen and (max-width: 991px) {\n    margin-bottom: 50px;\n    & h4 {\n      font-size: 20px;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & h4 {\n      font-size: 18px;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    & h4 {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        '\n  display: flex;\n  align-items: center;\n  margin-bottom: 150px;\n  & img {\n    margin-right: 20px;\n  }\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    & h2 {\n      margin-bottom: 100px;\n    }\n\n    & p {\n      margin-bottom: 50px;\n      word-break: keep-all;\n    }\n\n    & a {\n      background-image: url("/assets/imgs/page/esg/esg_btn_off.png");\n      background-position: center;\n      background-repeat: no-repeat;\n      width: 215px;\n      height: 50px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: #fff !important;\n      font-size: 1.1rem;\n      cursor: pointer;\n\n      :hover {\n        background-image: url("/assets/imgs/page/esg/esg_btn_on.png");\n      }\n\n      & span {\n        margin-left: 5px;\n      }\n    }\n  }\n  @media screen and (max-width: 991px) {\n    margin-bottom: 50px;\n    & img {\n      width: 50%;\n    }\n    & div {\n      width: calc(50% - 20px);\n\n      & h2 {\n        font-size: 24px;\n        margin-bottom: 50px;\n      }\n      p {\n        margin-bottom: 30px;\n      }\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & div {\n      width: 50%;\n      & h2 {\n        margin-bottom: 20px;\n      }\n      p {\n        margin-bottom: 20px;\n      }\n      & a {\n        width: 100%;\n        font-size: 16px;\n        border-radius: 20px;\n        span {\n          display: none;\n        }\n      }\n    }\n  }\n  @media screen and (max-width: 575px) {\n  }\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.2;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 100px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3de3f69-0"
})(_templateObject());
// 공통
var CommonTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3de3f69-1"
})(_templateObject1());
var CommonUnderBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3de3f69-2"
})(_templateObject2());
var HeadWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3de3f69-3"
})(_templateObject3());
var BodyWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3de3f69-4"
})(_templateObject4());
var ImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3de3f69-5"
})(_templateObject5());
var DescWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3de3f69-6"
})(_templateObject6());
var CardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3de3f69-7"
})(_templateObject7());
var CardRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3de3f69-8"
})(_templateObject8());
var H1Font = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-3de3f69-9"
})(_templateObject9());
var H1FontBottom = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-3de3f69-10"
})(_templateObject10());

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/esg-guide/Esg-guide.js






var EsgGuide = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonTitle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(H1Font, {
                                    children: "ESG\uC790\uB8CC\uC2E4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonUnderBar, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "\u2018\uC9C0\uC18D\uAC00\uB2A5\uC131\u2019\uC774 \uAE30\uC5C5\uC5D0 \uB300\uD55C \uC0C8\uB85C\uC6B4 \uD22C\uC790 \uAE30\uC900\uC774 \uB418\uBA74\uC11C ESG \uACBD\uC601\uC804\uB7B5\uC774 \uC138\uACC4\uC801 \uAD00\uC2EC\uC744 \uBC1B\uACE0 \uC788\uC2B5\uB2C8\uB2E4.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "ESG\uB780 \uAE30\uC5C5\uC758 \uBE44\uC7AC\uBB34\uC801 \uC694\uC18C\uC778",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "\uD658\uACBD(Environment), \uC0AC\uD68C(Social), \uC9C0\uBC30\uAD6C\uC870(Governance)"
                                }),
                                "\uB97C \uB73B\uD558\uBA70",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "\uC7A5\uAE30\uC801\uC778 \uAD00\uC810\uC5D0\uC11C \uCE5C\uD658\uACBD \uBC0F \uC0AC\uD68C\uC801 \uCC45\uC784\uACBD\uC601\uACFC \uD22C\uBA85\uACBD\uC601\uC744 \uD1B5\uD574 \uC9C0\uC18D\uAC00\uB2A5\uD55C \uBC1C\uC804\uC744 \uCD94\uAD6C\uD558\uB294 \uAC83\uC774 \uBC14\uB85C ESG \uACBD\uC601\uC785\uB2C8\uB2E4."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/imgs/page/esg/esgIcons_plus_text.png",
                                alt: "ESG\uC758 \uAD6C\uC131 \uC694\uC18C: \uD658\uACBD, \uC0AC\uD68C, \uC9C0\uBC30\uAD6C\uC870",
                                width: 800,
                                height: 400
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DescWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                children: [
                                    "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ESG\uC790\uB8CC\uC2E4\uC744 \uD1B5\uD574 \uAE30\uC5C5\uC758 \uC2E4\uBB34\uC790\uAC00 \uBC18\uB4DC\uC2DC \uC54C\uC544\uC57C \uD558\uB294 ESG \uAD00\uB828 \uC0C8\uB85C\uC6B4 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\uD658\uACBD \uC815\uCC45"
                                    }),
                                    "\uACFC",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: " \uD3EC\uC7A5\uC7AC \uD2B8\uB80C\uB4DC"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\uC2E4\uC81C \uC801\uC6A9 \uC0AC\uB840"
                                    }),
                                    " \uB4F1\uC744 \uC18C\uAC1C\uD574\uB4DC\uB9BD\uB2C8\uB2E4."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/page/esg/esg_card_1.png",
                                                alt: "ESG \uD658\uACBD\uB274\uC2A4 \uC774\uBBF8\uC9C0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(H1FontBottom, {
                                                        children: "ESG \uD658\uACBD\uB274\uC2A4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "\uAE30\uC5C5 \uB0B4 ESG \uC815\uCC45\uC758 \uBC29\uD5A5\uC131\uC744 \uC815\uD558\uACE0 \uBE60\uB974\uAC8C \uB300\uC751\uD558\uB294\uB370 \uAC00\uC7A5 \uAE30\uBCF8 \uC815\uBCF4\uC778 \uD658\uACBD \uC815\uCC45\uACFC \uAD00\uB828 \uB274\uC2A4\uB97C \uC804\uD574\uB4DC\uB9BD\uB2C8\uB2E4."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/esg-guide/news/",
                                                        children: "ESG \uD658\uACBD\uB274\uC2A4 \uBCF4\uB7EC\uAC00\uAE30"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "https://file.caretbio.com/caretbio/\u1102\u1172\u1109\u1173\u1105\u1166\u1110\u1165_\u110B\u1175\u1106\u1175\u110C\u1175.png",
                                                alt: "\u1102\u1172\u1109\u1173\u1105\u1166\u1110\u1165 \uC774\uBBF8\uC9C0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(H1FontBottom, {
                                                        children: "ESG \uB274\uC2A4\uB808\uD130"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "\uCD5C\uC2E0 \uD658\uACBD \uC815\uCC45\uACFC \uB274\uC2A4, \uC2E0\uC81C\uD488 \uCD9C\uC2DC \uC18C\uC2DD\uC744 \uAC00\uC7A5 \uBA3C\uC800 \uC804\uD574\uB4DC\uB9BD\uB2C8\uB2E4."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/esg-guide/letter/",
                                                        children: "ESG \uB274\uC2A4\uB808\uD130 \uBCF4\uB7EC\uAC00\uAE30"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/page/esg/esg_card_2.png",
                                                alt: "\uC18C\uC7AC\uC640 \uD3EC\uC7A5\uC7AC \uC774\uBBF8\uC9C0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(H1FontBottom, {
                                                        children: "\uC18C\uC7AC\uC640 \uD3EC\uC7A5\uC7AC"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "\uB2E4\uC591\uD55C \uD3EC\uC7A5\uC7AC\uC758 \uC18C\uC7AC\uC640 \uC885\uB958\uB97C \uB354\uC6B1 \uC54C\uAE30 \uC27D\uAC8C \uC124\uBA85\uD574\uB4DC\uB9BD\uB2C8\uB2E4."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/esg-guide/blog/package",
                                                        children: "\uC18C\uC7AC\uC640 \uD3EC\uC7A5\uC7AC \uC54C\uC544\uBCF4\uAE30"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/page/esg/esg_card_3.png",
                                                alt: "\uC81C\uC791\uC0AC\uB840 \uD3EC\uC7A5\uC7AC \uC774\uBBF8\uC9C0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/esg-guide/blog/make",
                                                        children: "\uC0AC\uB840 & \uB9AC\uBDF0 \uBCF4\uB7EC\uAC00\uAE30"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Esg_guide = (EsgGuide);

// EXTERNAL MODULE: ./components/esg-guide/Esg-layout.js
var Esg_layout = __webpack_require__(28680);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./pages/esg-guide/index.js





var EsgGuidePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "ESG\uC790\uB8CC\uC2E4",
            pageTitle: SeoMeta/* SeoMeta.esgLibrary.title */.e.esgLibrary.title,
            pageDesc: SeoMeta/* SeoMeta.esgLibrary.description */.e.esgLibrary.description,
            pageKeyword: SeoMeta/* SeoMeta.esgLibrary.keywords */.e.esgLibrary.keywords,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Esg_layout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Esg_guide, {})
                })
            })
        })
    });
};
/* harmony default export */ var esg_guide = (EsgGuidePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,4027,8680,9774,2888,179], function() { return __webpack_exec__(39386); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);